Apt.fn.make('auth', {
	init: function() {
		this.$private.initializeAuth();
	},

	/**
	 * Get CSRF token
	 *
	 * @param {Function} [fn]
	 */
	token: function(fn) {
		this.$private.fetchToken(fn);
	},

	/**
	 * Reset CSRF token
	 */
	reset: function() {
		this.$drop('token');
	},

	/**
	 * Manually check and handle registration page state
	 * Useful for triggering after dynamic content changes
	 */
	checkRegistrationPage: function() {
		this.$private.handleNavigation();
	},

	/**
	 * Aggressively remove all reCAPTCHA elements
	 * Use: Apt.auth.forceCleanup() in console if needed
	 */
	forceCleanup: function() {
		this.$private.aggressiveCleanup();
	},

	/**
	 * Unload module
	 */
	unload: function() {
		this.$private.cleanup();
		$.events.reset('auth');
	}
}, {
	/**
	 * Initialize authentication and navigation handlers
	 */
	initializeAuth: function() {
		// Set initial path for tracking
		var currentPath = window.location.pathname + window.location.search + window.location.hash;
		this.$set('lastCheckedPath', currentPath);

		// Set up navigation listeners for reCAPTCHA management
		this.setupNavigationListeners();

		// Check if we're currently on a registration page
		if (this.isRegistrationPage()) {
			this.loadRecaptcha();
		} else {
			this.bind();
		}
	},

	/**
	 * Set up navigation event listeners
	 */
	setupNavigationListeners: function() {
		var scope = this;

		// Listen for browser back/forward navigation
		$.events.on(window, 'popstate.auth', function() {
			setTimeout(function() {
				scope.handleNavigation();
			}, 100);
		});

		// Listen for hash changes (if using hash-based routing)
		$.events.on(window, 'hashchange.auth', function() {
			setTimeout(function() {
				scope.handleNavigation();
			}, 100);
		});

		// Listen for custom navigation events that might be triggered by Apt.history
		$.events.on(document, 'DOMContentLoaded.auth', function() {
			scope.handleNavigation();
		});

		// Listen for any custom events your app might trigger on navigation
		$.events.on(document, 'pageChanged.auth navigationComplete.auth', function() {
			setTimeout(function() {
				scope.handleNavigation();
			}, 50);
		});

		// Fallback: Watch for DOM changes that might indicate navigation
		if (typeof MutationObserver !== 'undefined') {
			var observer = new MutationObserver(function(mutations) {
				var hasSignificantChange = mutations.some(function(mutation) {
					return mutation.type === 'childList' &&
						   mutation.addedNodes.length > 0 &&
						   Array.from(mutation.addedNodes).some(function(node) {
							   return node.nodeType === Node.ELEMENT_NODE &&
									  (node.tagName === 'FORM' || node.querySelector('form'));
						   });
				});

				if (hasSignificantChange) {
					setTimeout(function() {
						scope.handleNavigation();
					}, 100);
				}
			});

			observer.observe(document.body, {
				childList: true,
				subtree: true
			});

			this.$set('mutationObserver', observer);
		}

		// Set up a periodic check as a final fallback
		this.navigationCheckInterval = setInterval(function() {
			var currentPath = window.location.pathname + window.location.search + window.location.hash;
			var lastPath = scope.$get('lastCheckedPath');

			if (currentPath !== lastPath) {
				scope.$set('lastCheckedPath', currentPath);
				scope.handleNavigation();
			}
		}, 1000);
	},

	/**
	 * Handle navigation events
	 */
	handleNavigation: function() {
		if (this.isRegistrationPage()) {
			if (!this.$get('recaptchaLoaded')) {
				this.loadRecaptcha();
			}
		} else {
			this.removeRecaptcha();
			this.bind();
		}
	},

	/**
	 * Check if current page is a registration page
	 */
	isRegistrationPage: function() {
		// Simple check: registration page has g-recaptcha element
		return !!document.getElementById('g-recaptcha');
	},

	/**
	 * Load reCAPTCHA for registration pages
	 */
	loadRecaptcha: function() {
		var scope = this;
		var captchaTarget = document.getElementById('g-recaptcha');

		if (!captchaTarget) {
			// No reCAPTCHA target found, just bind normally
			this.bind();
			return;
		}

		if (this.$get('recaptchaLoaded')) {
			// Already loaded, just bind
			this.bind();
			return;
		}

		if (typeof grecaptcha === 'undefined') {
			$.assets.load({
				js: 'https://www.google.com/recaptcha/enterprise.js?render=6Lc8pFgrAAAAAJ7YTkShWZTMFKnssblVkrhIubUv',
				success: function() {
					scope.initializeRecaptcha(captchaTarget);
				},
				error: function() {
					scope.bind();
				}
			});
		} else {
			this.initializeRecaptcha(captchaTarget);
		}
	},

	/**
	 * Initialize reCAPTCHA widget
	 */
	initializeRecaptcha: function(captchaTarget) {
		var scope = this;

		if (!captchaTarget || typeof grecaptcha === 'undefined') {
			this.bind();
			return;
		}

		grecaptcha.enterprise.ready(function() {
			try {
				// Clear any existing widget first
				captchaTarget.innerHTML = '';

				var widgetId = grecaptcha.enterprise.render(captchaTarget, {
					sitekey: '6Lc8pFgrAAAAAJ7YTkShWZTMFKnssblVkrhIubUv',
					size: 'invisible',
					badge: 'bottomright',
					'expired-callback': function() {
						// Reset the widget when token expires
						try {
							grecaptcha.enterprise.reset(widgetId);
						} catch (e) {
							// Silent fail
						}
					}
				});

				scope.$set('recaptchaLoaded', true);
				scope.$set('recaptchaWidgetId', widgetId);

				// Add a small delay before binding to ensure widget is fully ready
				setTimeout(function() {
					scope.bind();
				}, 200);
			} catch (error) {
				scope.bind();
			}
		});
	},

	/**
	 * Remove reCAPTCHA completely
	 */
	removeRecaptcha: function() {
		if (!this.$get('recaptchaLoaded')) {
			return;
		}

		try {
			// Reset widget if it exists
			var widgetId = this.$get('recaptchaWidgetId');
			if (typeof grecaptcha !== 'undefined' && widgetId !== undefined) {
				grecaptcha.enterprise.reset(widgetId);
			}

			// Remove reCAPTCHA badge element completely
			var badges = document.querySelectorAll('.grecaptcha-badge');
			badges.forEach(function(badge) {
				if (badge && badge.parentNode) {
					badge.parentNode.removeChild(badge);
				}
			});

			// Remove any other reCAPTCHA containers
			var recaptchaContainers = document.querySelectorAll('[class*="grecaptcha"], [id*="grecaptcha"], [class*="recaptcha"], [id*="recaptcha"]');
			recaptchaContainers.forEach(function(element) {
				// Don't remove our target element
				if (element.id !== 'g-recaptcha' && element.parentNode) {
					element.parentNode.removeChild(element);
				}
			});

			// Remove any reCAPTCHA scripts
			var recaptchaScripts = document.querySelectorAll('script[src*="recaptcha"], script[src*="gstatic.com/recaptcha"]');
			recaptchaScripts.forEach(function(script) {
				if (script.parentNode) {
					script.parentNode.removeChild(script);
				}
			});

			// Remove any reCAPTCHA stylesheets
			var recaptchaStyles = document.querySelectorAll('link[href*="recaptcha"], style[data-styled*="recaptcha"]');
			recaptchaStyles.forEach(function(style) {
				if (style.parentNode) {
					style.parentNode.removeChild(style);
				}
			});

			// Clear stored state
			this.$drop('recaptchaLoaded');
			this.$drop('recaptchaWidgetId');

		} catch (error) {
			// Silent error handling
		}
	},

	/**
	 * Aggressive cleanup for stubborn reCAPTCHA elements
	 */
	aggressiveCleanup: function() {
		try {
			// Remove all possible reCAPTCHA elements by various selectors
			var selectors = [
				'.grecaptcha-badge',
				'[class*="grecaptcha"]',
				'[id*="grecaptcha"]',
				'[class*="recaptcha"]',
				'[id*="recaptcha"]',
				'iframe[src*="recaptcha"]',
				'iframe[src*="gstatic"]',
				'div[style*="recaptcha"]',
				'[data-recaptcha]'
			];

			selectors.forEach(function(selector) {
				var elements = document.querySelectorAll(selector);
				elements.forEach(function(element) {
					// Don't remove our target element
					if (element.id !== 'g-recaptcha' && element.parentNode) {
						element.parentNode.removeChild(element);
					}
				});
			});

			// Also remove any inline styles that might be left behind
			var styleElements = document.querySelectorAll('style');
			styleElements.forEach(function(style) {
				if (style.textContent && style.textContent.includes('grecaptcha')) {
					if (style.parentNode) {
						style.parentNode.removeChild(style);
					}
				}
			});

			// Reset global grecaptcha if it exists
			if (typeof window.grecaptcha !== 'undefined') {
				try {
					delete window.grecaptcha;
				} catch (e) {
					window.grecaptcha = undefined;
				}
			}

			// Clear our state completely
			this.$drop('recaptchaLoaded');
			this.$drop('recaptchaWidgetId');

		} catch (error) {
			// Silent cleanup error
		}
	},

	/**
	 * Cleanup method
	 */
	cleanup: function() {
		this.removeRecaptcha();

		// Clean up mutation observer
		var observer = this.$get('mutationObserver');
		if (observer) {
			observer.disconnect();
			this.$drop('mutationObserver');
		}

		// Clear interval
		if (this.navigationCheckInterval) {
			clearInterval(this.navigationCheckInterval);
			this.navigationCheckInterval = null;
		}

		// Remove navigation listeners
		$.events.off(window, '.auth');
		$.events.off(document, '.auth');
	},

	/**
	 * Bind authentication forms
	 */
	bind: function() {
		var scope = this;
		var $form = $$('authForm');

		if (!$form.length) {
			// No auth form found on current page
			return;
		}

		// Unbind any existing handlers to prevent duplicates
		$form.off('submit.auth');

		$form.on('submit.auth', function(event) {
			event.preventDefault();

			var data = $form.serialize(true);

			$($._body).addClass('-is-replacing');

			// Only generate reCAPTCHA token for registration forms on registration pages
			if (data.action === 'users/save-user' &&
				scope.isRegistrationPage() &&
				typeof grecaptcha !== 'undefined' &&
				grecaptcha.enterprise &&
				scope.$get('recaptchaLoaded')) {

				// Ensure reCAPTCHA is ready before executing
				grecaptcha.enterprise.ready(function() {
					var widgetId = scope.$get('recaptchaWidgetId');

					// Reset the widget to ensure fresh token
					if (widgetId !== undefined) {
						try {
							grecaptcha.enterprise.reset(widgetId);
						} catch (e) {
							// Silent fail
						}
					}

					// Execute with a small delay to ensure everything is ready
					setTimeout(function() {
						grecaptcha.enterprise.execute('6Lc8pFgrAAAAAJ7YTkShWZTMFKnssblVkrhIubUv', {
							action: 'REGISTER'
						}).then(function(token) {
							if (token && token.length > 0) {
								data['g-recaptcha-response'] = token;
								scope.submitForm(data);
							} else {
								scope.submitForm(data);
							}
						}).catch(function() {
							scope.submitForm(data);
						});
					}, 100);
				});
			} else {
				scope.submitForm(data);
			}
		});

		// Bind logout functionality
		$$('logout').off('click.auth').on('click.auth', function() {
			scope.$public.reset();
			if (typeof Apt.wishlists !== 'undefined') {
				Apt.wishlists.fetch(null, true);
			}
			if (typeof $.history !== 'undefined') {
				$.history.go('/');
			} else {
				window.location.href = '/';
			}
		});
	},

	/**
	 * Fetch token
	 *
	 * @param {Function} [fn]
	 */
	fetchToken: function(fn) {
		var scope = this,
			token = scope.$get('token');

		if (token) {
			if (fn) {
				fn(token);
			}
			return;
		}

		$.fetch.request({
			url: 'token',
			json: true,
			success: function(data) {
				token = data.value;
				scope.$set('token', token);

				if (fn) {
					fn(token);
				}
			},
			error: function() {
				if (fn) {
					fn(null);
				}
			}
		});
	},

	/**
	 * Submit form with data
	 *
	 * @param {Object} data
	 */
	submitForm: function(data) {
		$.fetch.request({
			url: '/',
			method: 'post',
			data: data,
			json: true,
			type: 'form',
			success: function(response) {
				if (response.error || Object.values(response.errors || {}).length) {
					var message = response.error || Object.values(response.errors).shift().shift();

					if (typeof Apt.flash !== 'undefined') {
						Apt.flash.error(message);
					}

					$($._body).removeClass('-is-replacing');

					return;
				}

				$.history.go(response.redirect)
			},
			error: function(xhr) {
				try {
					var response = JSON.parse(xhr.responseText);

					if (response.error || Object.values(response.errors || {}).length) {
						var message = response.error || Object.values(response.errors).shift().shift();

						if (typeof Apt.flash !== 'undefined') {
							Apt.flash.error(message);
						}
					}

					var p = document.querySelector('.block-body p');
					if (p && response.error) {
						p.innerHTML = response.error;
					}
				} catch (e) {
					console.error('Failed to parse error response:', e);
				}

				$($._body).removeClass('-is-replacing');
			}
		});
	}
});
